import { useContext } from "react";
import { SnackBarContext } from "../SnackBarProvider";

export const useSnackBar = () => useContext(SnackBarContext);